export default "__VITE_ASSET__66f47ebb__"